import React, { useEffect } from 'react';

import { TheNewHeader } from '@alife/the-new-header';

import PageStore from '@/stores/page';

import SubMenu from '@/module/sub-menu';

import countrySite from '@/common/country-site';
import doLog from '@/common/log';
import isNodeServer from '@/utils/isNodeServer';

export default function Menu(props: {
  productId: number;
  i18n: DetailTypes.I18n;
  showSA: boolean;
  abtest: DetailTypes.Abtest;
}) {
  const { productId, i18n, showSA = false, abtest } = props || {};
  const pageStore = PageStore(state => state);

  const setSubMenu = () => {
    if (isNodeServer()) return;
    // 右侧浮动
    try {
      const stickyElement = document.querySelector('.module_recommend');
      if (stickyElement) {
        const stickyObserver = new IntersectionObserver(([entry]) => {
          // 滚动超过主图，推荐消失浮动
          const isSticky = !entry.isIntersecting && window.scrollY > 700;
          document.querySelector('.layout-stick')?.classList.toggle('sticky', isSticky);
          document.querySelector('body')?.classList.toggle('sticky', isSticky);
          // 更新二级导航
          if (isSticky) {
            pageStore.setMenu(pageStore.subMenu);
            pageStore.setScreen(true);
            doLog('/sc.details.navigation', '', 'EXP');
            // free shipping 需要更新位置
            const freeShippingDom = document.querySelector('.module_free_shipping');
            if (freeShippingDom) {
              const bottomHeight = document.querySelector('.right-bottom')?.offsetHeight;
              freeShippingDom.style.bottom = `${bottomHeight}px`;
            }
          } else {
            pageStore.setScreen(false);
          }
        });
        stickyObserver.observe(stickyElement);
      }
    } catch (error) {
      console.warn(`sticky error! ${error}`);
    }
  };

  useEffect(() => {
    setSubMenu();
  }, []);

  return (
    <div className="top-header">
      <TheNewHeader
        // 3.4.0版本开始，site不再需要接入方传入，域名和site的映射逻辑已收拢到header内
        searchbarProps={{
          sceneInfo: {
            name: countrySite(),
            productId,
            bizScene: 'detailPCSearchBarHint',
          },
        }}
        smartAssistantProps={{
          show: showSA,
          source: 'detail',
        }}
        i18n={i18n}
        useCommonStyle={false}
        fixed={pageStore.secondScreen}
        shipToConfig={{
          showWriteTips: true,
        }}
        onLangChange={(lang = 'en_US') => {
          if (window.HEADER_DATA['sc-header-config']) {
            const { detailLinks, languageMaps } = window.HEADER_DATA['sc-header-config'];
            const targetLang = languageMaps[lang];
            const targetLink = detailLinks[targetLang];
            // 中国站特殊处理
            if (countrySite() === 'cn' || !countrySite()) {
              window.location.href = targetLink;
              return;
            }
          }
          window.location.reload();
        }}
        subConfig={{
          children: <SubMenu />,
          usePropsSub: pageStore.secondScreen,
        }}
        scenes="detail"
      />
    </div>
  );
}
